import './index.css';
import './App.css';
import './styles/Legal.css';
import './styles/410.css';
import './styles/Service.css';
import './styles/Departement.css';
import './styles/Ville.css';
import './styles/TopSerruriers.css';
import { enableStaticInteractions } from './staticInteractions';
const root=document.getElementById('root');
if(navigator.userAgent==='ReactSnap'||process.env.NODE_ENV!=='production'||!root?.hasChildNodes()) {
  import('./prerender');
} else if(document.readyState==='loading') {
  document.addEventListener('DOMContentLoaded',enableStaticInteractions,{once:true});
} else enableStaticInteractions();
